import React, {PropTypes} from 'react';
import moment from 'moment';
import {DEFAULT_TOURNAMENT_IMG} from 'shared/variables';

const TournamentItem = ({
  id,
  name,
  startDate,
  endDate,
  customImagePath,
  canCaptainPurchase,
  canCaptainManage,
  captainPurchaseReason,
  theme,
  onScheduleClick,
  onManageClick
}) => {
  const redGradient = `linear-gradient(rgba(183, 18, 52, 0.6), rgba(183, 18, 52, 0.7))`;
  const blueGradient = `linear-gradient(rgba(0, 51, 141, 0.6), rgba(0, 51, 141, 0.7))`;
  const orangeGradient = `linear-gradient(rgba(255, 105, 19, 0.4), rgba(255, 106, 19, 0.5))`;
  let gradient = blueGradient;

  if(theme == 'red') {
    gradient = redGradient;
  } 
  else if(theme == 'orange') {
    gradient = orangeGradient;
  }

  return (
    <div className="card">
    <div className="card-heading"
      style={{
        background: `${gradient},
          url(${customImagePath || DEFAULT_TOURNAMENT_IMG})
          no-repeat center center`,
        backgroundSize: 'cover'
      }}>
      <h3>{name}</h3>
      <small>{`Starts: ${moment.parseZone(startDate).format('M/D/YYYY')}, Ends: ${moment.parseZone(endDate).format('M/D/YYYY')}`}</small>
    </div>
    { captainPurchaseReason
      ? <div className="panel-body alert-danger">
          { captainPurchaseReason }
        </div>
      : null 
    }
    { canCaptainPurchase || canCaptainManage
      ? <div className="panel-body">
          <div className="flex space-around">
            { canCaptainPurchase
              ? <button
                  className="btn btn-primary btn-lg"
                  type="button"
                  onClick={() => onScheduleClick(id)}
                ><i className="fa fa-calendar"/> {'Register'}</button>
              : null 
            }
            <button
              className="btn btn-secondary"
              type="button"
              onClick={() => onManageClick(id)}
            ><i className="fa fa-wrench"/> {'Manage'}</button>
          </div>
        </div>
      : null 
    }
  </div>
  );
};

TournamentItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  customImagePath: PropTypes.string,
  canCaptainPurchase:PropTypes.bool.isRequired,
  canCaptainManage:PropTypes.bool.isRequired,
  captainPurchaseReason: PropTypes.string,
  theme: PropTypes.string,
  onScheduleClick: PropTypes.func.isRequired,
  onManageClick: PropTypes.func.isRequired
};

export default TournamentItem;



// WEBPACK FOOTER //
// ./src/features/registration/home/TournamentItem.jsx